import React from 'react';
import { Help as HelpIcon } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { TourButtonProps } from './TourButton.props';

const TourButton = ({ onStartTour }: TourButtonProps) => (
  <Tooltip title="Start guided tour" arrow>
    <Button
      variant="outlined"
      size="small"
      startIcon={<HelpIcon />}
      onClick={onStartTour}
      style={{ marginLeft: 8 }}
      data-tour="tour-button"
    >
      Help Tour
    </Button>
  </Tooltip>
);

export default TourButton;
